const { API_URL } = require('../../app.config');

export async function loginUser({ email, password }) {
	const body = JSON.stringify({
		email,
		password
	});

	let response = await fetch(API_URL + '/auth/login', {
		method: 'POST',
		body,
		headers: {
			'Content-Type': 'application/json'
		}
	}).then((response) => {
		localStorage.setItem('token', response.headers.get('authorization'));
		return response.json();
	});

	return response;;
}

export async function registerUser({
	name,
	age,
	city,
	
	genre,
	albumsPublished,
	tracksPublished,
	formation,
	
	email,
	password,
	confirmPassword
}) {
	const body = JSON.stringify({
		name,
		age,
		city,
		
		genre,
		albumsPublished,
		tracksPublished,
		formation,

		email,
		password,
		confirmPassword
	});

	let response = await fetch(API_URL + '/auth/register', {
		method: 'POST',
		body,
		headers: {
			'Content-Type': 'application/json'
		}
	}).then((response) => response.json());

	if (response.success) return response;
	else throw response.message;
}

export async function forgetPassword({ email }) {
	let response = await fetch(API_URL + '/auth/forget/' + email, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		}
	}).then((response) => response.json());

	if (response.success) return response;
	else throw response.message;
}

export async function resetPassword({ userId, password, token }) {
	if (userId && password && token) {
		let body = JSON.stringify({
			password
		});

		let response = await fetch(API_URL + '/auth/reset/' + userId + '?token=' + token, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body
		}).then((response) => response.json());

		if (response.success) return response;
		else throw response.message;
	} else throw 'Parametri mancanti';
}

// module.exports = { loginUser, registerUser, forgetPassword, resetPassword };

export async function authorizeSpotify() {
	let token = localStorage.getItem('token');

	let headers = new Headers();
	headers.append('Authorization', token);
	headers.append('Content-Type', 'application/json');

	let response = await fetch(API_URL + '/users/spotify', {
		method: 'GET',
		headers
	}).then((response) => response.json());

	if (response.success) return response;
	else throw response.message;
}